var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00391 3.83335C9.00391 3.46516 8.70543 3.16669 8.33724 3.16669C7.96905 3.16669 7.67057 3.46516 7.67057 3.83335L7.67057 7.83335L3.67057 7.83335C3.30238 7.83335 3.00391 8.13183 3.00391 8.50002C3.00391 8.86821 3.30238 9.16669 3.67057 9.16669H7.67057L7.67057 13.1667C7.67057 13.5349 7.96905 13.8334 8.33724 13.8334C8.70543 13.8334 9.00391 13.5349 9.00391 13.1667L9.00391 9.16669L13.0039 9.16669C13.3721 9.16669 13.6706 8.86821 13.6706 8.50002C13.6706 8.13183 13.3721 7.83335 13.0039 7.83335L9.00391 7.83335V3.83335Z",
    fill: "#FFFF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus1);
export default __webpack_public_path__ + "static/media/plus1.ba427b5b7f8159e9284d381cc4ac1239.svg";
export { ForwardRef as ReactComponent };